import { FormBase } from 'core/components';
import validatorjs from 'validatorjs';

export default class MarkAsShippedForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseId',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'trackingNumber',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.TRACKINGNUMBER',
					rules: 'required',
				},
				{
					name: 'carrierServiceId',
					label: 'CHANGESHIPPINGVIEW.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'cost',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.COST',
					rules: 'required|numeric|decimalLength|numericMinValue',
				},
				{
					name: 'shippingCostSurcharge',
					label: 'FULFILLMENTORDER.MARKASSHIPPEDMODAL.SURPLUSCHARGE',
					rules: 'numeric|decimalLength|numericMinValue',
				},
				{
					name: 'isInternal',
					value: true,
					type: 'checkbox',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/MarkAsShippedForm.js